import React from 'react';

type ConditionalWrapperProps = {
    condition: boolean | undefined;
    wrapper: (node: React.ReactNode) => React.ReactElement;
    children: React.ReactElement;
};

export const ConditionalWrapper = ({
    condition,
    wrapper,
    children,
}: ConditionalWrapperProps): React.ReactElement => (condition ? wrapper(children) : children);
